
const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

export default function SeoJsonLd() {
  const localBusiness = {
    '@context': 'https://schema.org',
    '@type': 'AccountingService',
    name: 'Butler Professional Services',
    description:
      'Precision accounting and bookkeeping services for small businesses, nonprofits, real estate professionals, and insurance agencies. Over 30 years of experience.',
    url: SITE_URL,
    logo: 'https://static.readdy.ai/image/7f87cd0470b0952245d57f0e6ea3c4d4/1195916e21ce0a96496e218c7ced9947.png',
    image: 'https://static.readdy.ai/image/7f87cd0470b0952245d57f0e6ea3c4d4/affbab386fd90230ee90a11e295d99d2.jpeg',
    telephone: '+15103503216',
    email: 'bps.antonia@gmail.com',
    foundingDate: '1993',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '2415 San Ramon Valley Blvd, Ste 4229',
      addressLocality: 'San Ramon',
      addressRegion: 'CA',
      postalCode: '94583',
      addressCountry: 'US',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 37.7799,
      longitude: -121.978,
    },
    areaServed: {
      '@type': 'State',
      name: 'California',
    },
    priceRange: '$$',
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '17:00',
      },
    ],
    sameAs: [],
  };

  const webPage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Butler Professional Services | Precision Accounting & Bookkeeping San Ramon CA',
    description:
      'Butler Professional Services offers precision accounting and bookkeeping in San Ramon, CA. Serving small businesses, nonprofits, real estate professionals, and insurance agencies since 1993.',
    url: SITE_URL,
    inLanguage: 'en-US',
    isPartOf: {
      '@type': 'WebSite',
      name: 'Butler Professional Services',
      url: SITE_URL,
    },
    about: {
      '@type': 'AccountingService',
      name: 'Butler Professional Services',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: SITE_URL,
        },
      ],
    },
  };

  const person = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Antonia Mayweather',
    jobTitle: 'Owner & Principal Accountant',
    worksFor: {
      '@type': 'AccountingService',
      name: 'Butler Professional Services',
    },
    alumniOf: [
      {
        '@type': 'CollegeOrUniversity',
        name: 'California State University, Hayward',
      },
      {
        '@type': 'CollegeOrUniversity',
        name: 'University of Cambridge',
      },
      {
        '@type': 'CollegeOrUniversity',
        name: 'Harvard Kennedy School',
      },
    ],
  };

  const faq = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What accounting and bookkeeping services does Butler Professional Services offer?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Butler Professional Services offers full-charge bookkeeping, QuickBooks setup and training, payroll processing, financial reporting, nonprofit accounting, real estate accounting, and insurance agency bookkeeping.',
        },
      },
      {
        '@type': 'Question',
        name: 'Where is Butler Professional Services located?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We are located at 2415 San Ramon Valley Blvd, Ste 4229, San Ramon, CA 94583.',
        },
      },
      {
        '@type': 'Question',
        name: 'How long has Butler Professional Services been in business?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Butler Professional Services has been providing precision accounting and bookkeeping services since 1993 — over 30 years of trusted experience.',
        },
      },
      {
        '@type': 'Question',
        name: 'Does Butler Professional Services work with nonprofits?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes. We specialize in nonprofit accounting and financial stewardship, with credentials from Harvard Kennedy School in Nonprofit Financial Stewardship.',
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusiness) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPage) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(person) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faq) }}
      />
    </>
  );
}